import { mapGetters } from 'vuex'
import Add from './add.dialog.vue'
import partner from '../../../../api/partner'
import journal from '@/api/journal'

const columns = [
  {
    title: '',
    enTitle: 'Name',
    width: 150,
    dataIndex: 'name',
    slot: 'html'
  },
  {
    title: '',
    enTitle: 'Image',
    width: 200,
    dataIndex: 'picture',
    slot: 'img'
  },
  {
    title: '',
    enTitle: 'Link',
    width: 200,
    dataIndex: 'linkAddress',
    slot: 'link'
  },
  {
    title: '',
    enTitle: 'Operation Time',
    width: 120,
    dataIndex: 'updateTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 80,
    dataIndex: 'released',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    Add
  },
  data() {
    return {
      columns,
      isVisable: false,
      dataSource: [],
      params: {
        released: ''
      },
      displayPartner: false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      journalId: 'getJournalId',
      user: 'getUser'
    })
  },
  watch: {
    journalId: {
      handler() {
        this.getList()
        this.partnerStatus()
      },
      immediate: true
    }
  },
  methods: {
    async getList() {
      if (!this.journalId) {
        return
      }
      const data = Object.assign(this.params, { journalId: this.journalId })
      this.dataSource = await partner.getAll(data)
    },
    async partnerStatus() {
      let data = { journalId: this.journalId }
      let res = await journal.display(data)
      this.displayPartner = res.displayPartner
    },
    changeStatus(status) {
      this.params.released = status
      this.getList()
    },
    add() {
      this.isVisable = true
    },
    edit(val) {
      this.$refs['key-relationship-add'].getQuery(val.id)
      this.isVisable = true
    },
    async able(val) {
      const { id, released, version } = val
      await partner.release(id, !released, { version })
      let content = 'This Partner has been published!'
      if (released) {
        content = 'This Partner has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this Partner?',
        content:
          'Please be aware of once this Partner is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await partner.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Partner has been deleted!'
        })
        this.getList()
      })
    },
    async setSort(val) {
      val.forEach((item, index) => {
        item.sort = index
      })
      await partner.setSort(val)
      this.getList()
    },
    confirm() {
      this.getList()
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
    },
    async showPartner(val) {
      this.displayPartner = val
      let data = {
        journalId: this.journalId,
        display: this.displayPartner,
        type: 'PARTNER'
      }
      await journal.disEdit(data)
      this.partnerStatus()
    }
  }
}
